export const APP_NAME = 'Skin Forge';
export const APP_DESCRIPTION = 'Открывай кейсы и получай скины для Counter Strike 2';
export const APP_THEME = {
	primary: '#4A90E2',
	secondary: '#FFD700',
	background: '#1A1A1A',
	card: {
		background: '#2A2A2A',
		shadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
	},
	text: {
		primary: '#FFFFFF',
		secondary: 'rgba(255, 255, 255, 0.7)'
	}
}; 